import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Transfer.scss"; // Import your custom CSS file

const Transfer = () => {
  // State for Add Beneficiary
  const [beneficiaryData, setBeneficiaryData] = useState({
    mobile_number: "",
    bank_code: "",
    ifsc: "",
    beneficiary_name: "",
    beneficiary_mobile: "",
    beneficiary_account: "",
  });
  const [banks, setBanks] = useState([]);
  const [filteredBanks, setFilteredBanks] = useState([]); // State for filtered bank list
  const [bankSearch, setBankSearch] = useState(""); // State for bank search query
  const [addError, setAddError] = useState(null);
  const [addSuccess, setAddSuccess] = useState(null);

  // State for Delete Beneficiary
  const [deleteData, setDeleteData] = useState({
    mobile_number: "",
    recipient_id: "",
  });
  const [deleteError, setDeleteError] = useState(null);
  const [deleteSuccess, setDeleteSuccess] = useState(null);

  // State for Transfer Money
  const [transferData, setTransferData] = useState({
    mobile_number: "",
    amount: "",
    name: "",
  });
  const [transferError, setTransferError] = useState(null);
  const [transferSuccess, setTransferSuccess] = useState(null);

  // Fetch Bank List
  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await axios.get(
          "https://api.appmingleconsultants.com/paymingle/bankList/"
        );
        if (response.status === 200) {
          setBanks(response.data.banks);
          setFilteredBanks(response.data.banks); // Initialize filteredBanks with the full bank list
        }
      } catch (error) {
        console.error("Error fetching bank list:", error);
      }
    };
    fetchBanks();
  }, []);

  // Update the filtered bank list based on the search query
  useEffect(() => {
    const filtered = banks.filter((bank) =>
      bank.bank_name.toLowerCase().includes(bankSearch.toLowerCase())
    );
    setFilteredBanks(filtered);
  }, [bankSearch, banks]);

  // Handle Input Changes
  const handleChange = (e, setState) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  // Add Beneficiary
  const addBeneficiary = async (e) => {
    e.preventDefault();
    setAddError(null);
    setAddSuccess(null);

    try {
      const response = await axios.post(
        "https://api.appmingleconsultants.com/paymingle/addBeneficiary/",
        beneficiaryData
      );
      if (response.status === 200) {
        setAddSuccess("Beneficiary added successfully!");
        setBeneficiaryData({
          mobile_number: "",
          bank_code: "",
          ifsc: "",
          beneficiary_name: "",
          beneficiary_mobile: "",
          beneficiary_account: "",
        });
      } else {
        setAddError("Failed to add beneficiary. Please try again.");
      }
    } catch (error) {
      setAddError(error.response?.data?.message || "An error occurred.");
    }
  };
  // Delete Beneficiary
  const deleteBeneficiary = async (e) => {
    e.preventDefault();
    setDeleteError(null);
    setDeleteSuccess(null);

    try {
      const response = await axios.post(
        "https://api.appmingleconsultants.com/paymingle/deleteBeneficiary/",
        deleteData
      );
      if (response.status === 200) {
        setDeleteSuccess("Beneficiary deleted successfully!");
        setDeleteData({
          mobile_number: "",
          recipient_id: "",
          name: ""
        });
      } else {
        setDeleteError("Failed to delete beneficiary. Please try again.");
      }
    } catch (error) {
      setDeleteError(error.response?.data?.message || "An error occurred.");
    }
  };

  // Transfer Money
  const transferMoney = async (e) => {
    e.preventDefault();
    setTransferError(null);
    setTransferSuccess(null);

    try {
      const response = await axios.post(
        "https://api.appmingleconsultants.com/paymingle/transferMoney/",
        transferData
      );
      if (response.status === 200) {
        setTransferSuccess("Money transferred successfully!");
        setTransferData({
          mobile_number: "",
          amount: "",
          name: "",
        });
      } else {
        setTransferError("Failed to transfer money. Please try again.");
      }
    } catch (error) {
      setTransferError(error.response?.data?.message || "An error occurred.");
    }
  };
  
  return (
    <div className="transfer-container">
      <h1>Transfer Portal</h1>

      {/* Add Beneficiary Form */}
      <form onSubmit={addBeneficiary}>
        <h2>Add Beneficiary</h2>
        {addError && <p className="error">{addError}</p>}
        {addSuccess && <p className="success">{addSuccess}</p>}
        <div>
          <label>Mobile Number:</label>
          <input
            type="text"
            name="mobile_number"
            value={beneficiaryData.mobile_number}
            onChange={(e) => handleChange(e, setBeneficiaryData)}
            required
          />
        </div>
        <div>
          <label>Search Bank:</label>
          <input
            type="text"
            placeholder="Search for a bank"
            value={bankSearch}
            onChange={(e) => setBankSearch(e.target.value)} // Update search query
          />
        </div>
        <div>
          <label>Bank:</label>
          <select
            name="bank_code"
            value={beneficiaryData.bank_code}
            onChange={(e) => handleChange(e, setBeneficiaryData)}
            required
          >
            <option value="">Select Bank</option>
            {filteredBanks.map((bank) => (
              <option key={bank.bank_code} value={bank.bank_code}>
                {bank.bank_name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label>IFSC:</label>
          <input
            type="text"
            name="ifsc"
            value={beneficiaryData.ifsc}
            onChange={(e) => handleChange(e, setBeneficiaryData)}
            required
          />
        </div>
        <div>
          <label>Beneficiary Name:</label>
          <input
            type="text"
            name="beneficiary_name"
            value={beneficiaryData.beneficiary_name}
            onChange={(e) => handleChange(e, setBeneficiaryData)}
            required
          />
        </div>
        <div>
          <label>Beneficiary Mobile:</label>
          <input
            type="text"
            name="beneficiary_mobile"
            value={beneficiaryData.beneficiary_mobile}
            onChange={(e) => handleChange(e, setBeneficiaryData)}
            required
          />
        </div>
        <div>
          <label>Beneficiary Account:</label>
          <input
            type="text"
            name="beneficiary_account"
            value={beneficiaryData.beneficiary_account}
            onChange={(e) => handleChange(e, setBeneficiaryData)}
            required
          />
        </div>
        <button type="submit">Add Beneficiary</button>
      </form>
      
      {/* Delete Beneficiary Form */}
      <form onSubmit={deleteBeneficiary}>
        <h2>Delete Beneficiary</h2>
        {deleteError && <p className="error">{deleteError}</p>}
        {deleteSuccess && <p className="success">{deleteSuccess}</p>}
        <div>
          <label>Mobile Number:</label>
          <input
            type="text"
            name="mobile_number"
            value={deleteData.mobile_number}
            onChange={(e) => handleChange(e, setDeleteData)}
            required
          />
        </div>
        <div>
          <label>Recipient ID:</label>
          <input
            type="text"
            name="recipient_id"
            value={deleteData.recipient_id}
            onChange={(e) => handleChange(e, setDeleteData)}
            required
          />
        </div>
        <button type="submit">Delete Beneficiary</button>
      </form>

      {/* Transfer Money Form */}
      <form onSubmit={transferMoney}>
        <h2>Transfer Money</h2>
        {transferError && <p className="error">{transferError}</p>}
        {transferSuccess && <p className="success">{transferSuccess}</p>}
        <div>
          <label>Mobile Number:</label>
          <input
            type="text"
            name="mobile_number"
            value={transferData.mobile_number}
            onChange={(e) => handleChange(e, setTransferData)}
            required
          />
        </div>
        <div>
          <label>Amount:</label>
          <input
            type="number"
            name="amount"
            value={transferData.amount}
            onChange={(e) => handleChange(e, setTransferData)}
            required
          />
        </div>
        <div>
          <label>Name:</label>
          <input
            type="text"
            name="name"
            value={transferData.name}
            onChange={(e) => handleChange(e, setTransferData)}
            required
          />
        </div>
        <button type="submit">Transfer Money</button>
      </form>
    </div>
  );
};

export default Transfer;
